class Emission {
  constructor({ _id, id, date, tons, year }) {
    this.id = id || _id;
    this.date = date;
    this.tons = tons;
    this.year = year;
  }
}

export default Emission;